import { Typography } from '@mui/material';
import { Circle } from '@mui/icons-material';

const StandardHoursListItem = ({ orderTypeWithTimeSlots, color }) => {
  return (
    <Typography
      variant="body1"
      sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}
    >
      <Circle sx={{ color, fontSize: 10 }} />
      {orderTypeWithTimeSlots}
    </Typography>
  );
};

export default StandardHoursListItem;
